export default __webpack_public_path__ + "a041ced92f750a84b7fe4fddcdd776bd.svg";